module.exports = __webpack_public_path__ + "cancellara-dist/img/sisalpay.e4b45cb5.png";